import { LoginTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const LoginTrackingSchema: Record<LoginTrackingPoint, string> = {
  [LoginTrackingPoint.PageView]: '5dcf52a7-aa38-4449-ae1b-063777de8465',
  [LoginTrackingPoint.LoginButtonClick]: '7a22d4dc-220f-4ca2-99be-a10d54d91e50',
  [LoginTrackingPoint.ForgotButtonClick]:
    '1a63ce02-a871-4072-9e3a-949a228fcb17',
  [LoginTrackingPoint.HelpButtonClick]: 'e8d6889f-54e3-4274-a6ec-cf20ae987c81',
  [LoginTrackingPoint.BackButtonClick]: 'a790bb3d-7271-4802-a93e-420f80e90965',
  [LoginTrackingPoint.SignupButtonClick]:
    'c30b2814-27f1-466b-94ec-e647f5b3cfa4',
  [LoginTrackingPoint.LoginSuccessAction]:
    '6fe5d469-e6a7-4247-8e64-734a78bd6485',
  [LoginTrackingPoint.LoginFailAction]: '8e9ea194-1f86-4fbb-a683-46726051bc99',
  [LoginTrackingPoint.LoginFailedToastAction]: '',
  [LoginTrackingPoint.LoginWithSMSButtonClick]:
    '914b85d6-0a5a-4791-834a-4ce3567d1f9f',
  [LoginTrackingPoint.LoginWithSMSNextButtonClick]:
    '3003c4d6-9319-41b4-8e13-300945ef17df',
  [LoginTrackingPoint.LoginWithSMSLoginWithPasswordButtonClick]:
    '7cde23dd-9aac-4d6b-8b8c-029688ddcb75',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupImpression]: '',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupOkButtonClick]: '',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupRefreshButtonClick]: '',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupCancelButtonClick]: '',
  [LoginTrackingPoint.LoginWithPasswordAddPhoneEmailPopupView]: '',
  [LoginTrackingPoint.LoginWithPasswordAddPhoneEmailPopupOkClick]: '',
  [LoginTrackingPoint.LoginWithThirdPartyGoogle]:
    '85bfbedb-2f43-44fd-a9e8-ceb9361ff155',
  [LoginTrackingPoint.LoginWithThirdPartyFacebook]:
    '03ab3f48-9fd5-48f9-a656-1874f5711ddf',
  [LoginTrackingPoint.LoginWithThirdPartyApple]:
    '28df0679-edc1-49ce-875f-31850efdbc3e',
  [LoginTrackingPoint.LoginWithThirdPartyShopee]:
    '8a151097-5190-4ee4-a14e-bd97de4fafbf',
  [LoginTrackingPoint.LoginByTokenSuccessAction]: '',
  [LoginTrackingPoint.QuickLoginToggleImpression]: '',
  [LoginTrackingPoint.QuickLoginToggleClick]: '',
  [LoginTrackingPoint.QuickLoginTooltipImpression]: '',
  [LoginTrackingPoint.QuickLoginActionSuccess]: '',
  [LoginTrackingPoint.LoginWithBusinessGoogleButtonClick]: '',
};

export const getLoginPageTypeAndSchema = (
  trackingPoint: LoginTrackingPoint
) => {
  return {
    page_type: PageType.LoginPage,
    schema: LoginTrackingSchema[trackingPoint],
  };
};
